export default from './share-link-form';



// WEBPACK FOOTER //
// ./app/components/share-link-form/index.js